import { gql } from "@apollo/client";

export const QUERY_GET_USER_TO_PROCESS = gql`
  query QUERY_GET_USER_TO_PROCESS($patientId: uuid, $processId: Int) {
    userToProcess(
      where: { processId: { _eq: $processId }, userId: { _eq: $patientId } }
    ) {
      created_at
      descript
      doctorId
      id
      isAcepted
      processId
      stageId
      updated_at
      userId
      isChecked
      nextUpdate
      user {
        phone
        documentNumber
        documentType
        id
        lastname
        name
        picture
        email
        enDocumentType {
          comment
          value
        }
      }
      processStage {
        id
        descript
        expirationTime
        isAutomatic
        nextStageId
        processId
        stageName
        frequency
        frequencyType
        groupStage {
          comment
          value
          groupStageTypes {
            typeMedicineStageId
          }
        }
      }
      process {
        id
        nameKey
        processName
      }
      userToProcessHistories(
        order_by: { created_at: desc }
        limit: 1
        where: { isChecked: { _eq: true } }
      ) {
        created_at
        customFormFieldChanges
        date
        descript
        doctorId
        id
        isChecked
        latestCustomFormId
        processId
        stageId
        userToProcessId
      }
    }
  }
`;

export const QUERY_GET_USER_AND_USER_TO_PROCESS = gql`
  query QUERY_GET_USER_AND_USER_TO_PROCESS(
    $emailPatient: String
    $processId: Int
  ) {
    user(where: { email: { _eq: $emailPatient } }) {
      birthdate
      email
      documentNumber
      documentType
      createdAt
      countryPhoneId
      id
      lastname
      name
      picture
      phone
      userToProcesses(where: { processId: { _eq: $processId } }) {
        created_at
        descript
        doctorId
        id
        isAcepted
        processId
        stageId
        updated_at
        userId
        isChecked
        nextUpdate
        user {
          phone
          documentNumber
          documentType
          id
          lastname
          name
          picture
          email
          enDocumentType {
            comment
            value
          }
        }
        processStage {
          id
          descript
          expirationTime
          isAutomatic
          nextStageId
          processId
          stageName
          frequency
          frequencyType
        }
        process {
          id
          nameKey
          processName
        }
        userToProcessHistories(
          order_by: { created_at: desc }
          limit: 1
          where: { isChecked: { _eq: true } }
        ) {
          created_at
          customFormFieldChanges
          date
          descript
          doctorId
          id
          isChecked
          latestCustomFormId
          processId
          stageId
          userToProcessId
        }
      }
    }
  }
`;

export const QUERY_GET_USER_AND_USER_TO_PROCESS_PHONE = gql`
  query QUERY_GET_USER_AND_USER_TO_PROCESS(
    $phonePatient: String
    $processId: Int
  ) {
    user(where: { phone: { _eq: $phonePatient } }) {
      birthdate
      email
      documentNumber
      documentType
      createdAt
      countryPhoneId
      id
      lastname
      name
      phone
      picture
      userToProcesses(where: { processId: { _eq: $processId } }) {
        created_at
        descript
        doctorId
        id
        isAcepted
        processId
        stageId
        updated_at
        userId
        isChecked
        nextUpdate
        user {
          phone
          documentNumber
          documentType
          id
          lastname
          name
          picture
          email
          enDocumentType {
            comment
            value
          }
        }
        processStage {
          id
          descript
          expirationTime
          isAutomatic
          nextStageId
          processId
          stageName
          frequency
          frequencyType
        }
        process {
          id
          nameKey
          processName
        }
        userToProcessHistories(
          order_by: { created_at: desc }
          limit: 1
          where: { isChecked: { _eq: true } }
        ) {
          created_at
          customFormFieldChanges
          date
          descript
          doctorId
          id
          isChecked
          latestCustomFormId
          processId
          stageId
          userToProcessId
        }
      }
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED = gql`
  query QUERY_GET_USER_TO_PROCESS(
    $limit: Int
    $offset: Int
    $where: userToProcess_bool_exp
    $orderBy: [userToProcess_order_by!]
  ) {
    userToProcess(
      where: $where
      limit: $limit
      offset: $offset
      order_by: $orderBy
    ) {
      id
      created_at
      doctorId
      isAcepted
      processId
      stageId
      updated_at
      userId
      isChecked
      nextUpdate
      stageExtraInfo
      user {
        documentNumber
        documentType
        id
        phone
        lastname
        name
        picture
        email
        phone
        countryPhoneId
        countryId
        cityId
        address
        birthdate
        gender
        address
        nameCarer
        lastnameCarer
        phoneCarer
        countryPhoneCarerId
        country {
          id
          name
        }
        city {
          id
          name
          stateId
          state {
            id
            name
          }
        }
        phoneCountry {
          phonecode
        }
        carerPhoneCountry {
          phonecode
        }
        userToProcesses {
          id
          descript
          stageId
          securityCode
          process {
            id
            processName
          }
        }
        enDocumentType {
          comment
          value
        }
        userToPatologies {
          typePatologyVal {
            name
            value
          }
        }
      }
      processStage {
        id
        descript
        expirationTime
        isAutomatic
        nextStageId
        processId
        stageName
        frequency
        frequencyType
        incremental
        groupStage {
          comment
          value
          groupStageTypes {
            typeMedicineStageId
          }
        }
      }
      process {
        id
        nameKey
        processName
      }
      userToProcessHistories(
        order_by: { created_at: desc }
        where: { isChecked: { _eq: true } }
      ) {
        created_at
        customFormFieldChanges
        date
        descript
        doctorId
        id
        isChecked
        latestCustomFormId
        processId
        stageId
        userToProcessId
      }
      userToBarriers_aggregate(where: { barrierStatus: { _eq: "pending" } }) {
        aggregate {
          count
        }
      }
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_COUNT_FILTERED = gql`
  query QUERY_GET_USER_TO_PROCESS_COUNT_FILTERED(
    $where: userToProcess_bool_exp
  ) {
    userToProcess_aggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_COUNT = gql`
  query QUERY_GET_USER_TO_PROCESS_COUNT {
    userToProcess_aggregate(where: { isAcepted: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED_NULL = gql`
  query QUERY_GET_USER_TO_PROCESS_BY_ISACEPTED_NULL {
    userToProcess(where: { isAcepted: { _is_null: true } }) {
      id
      created_at
      doctorId
      isAcepted
      processId
      stageId
      updated_at
      userId
      isChecked
      nextUpdate
      user {
        documentNumber
        documentType
        id
        lastname
        name
        picture
        email
        enDocumentType {
          comment
          value
        }
      }
      processStage {
        id
        descript
        expirationTime
        isAutomatic
        nextStageId
        processId
        stageName
        frequency
        frequencyType
      }
      process {
        id
        nameKey
        processName
      }
      userToProcessHistories(
        order_by: { created_at: desc }
        limit: 1
        where: { isChecked: { _eq: true } }
      ) {
        created_at
        customFormFieldChanges
        date
        descript
        doctorId
        id
        isChecked
        latestCustomFormId
        processId
        stageId
        userToProcessId
      }
    }
  }
`;
export const QUERY_GET_PROCESS_STAGES_BY_PROCESS_IDS = gql`
  query QUERY_GET_PROCESS_STAGES_BY_PROCESS_IDS($processIds: [Int!]) {
    process(where: { id: { _in: $processIds } }) {
      processStages(order_by: { stageName: asc }) {
        id
        descript
        expirationTime
        isAutomatic
        nextStageId
        processId
        stageName
        frequency
        frequencyType
        groupStageValue
        incremental
        groupStage {
          comment
          value
        }
      }
      descript
      icon
      id
      nameKey
      processName
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_COUNT_INC = gql`
  query QUERY_GET_USER_TO_PROCESS_COUNT_INC {
    userToProcess_aggregate(where: { processId: { _eq: 47 } }) {
      aggregate {
        count
      }
    }
  }
`;

export const QUERY_GET_USER_TO_PROCESS_COUNT_INEN = gql`
  query QUERY_GET_USER_TO_PROCESS_COUNT_INEN {
    userToProcess_aggregate(where: { processId: { _eq: 68 } }) {
      aggregate {
        count
      }
    }
  }
`;
